const { activePageType } = require('./handlePageType');
const { SINGLE_PAGE, LISTING_PAGE } = require('./constants');
const handleSinglePage = require('./handleSinglePage');
const handleListingPage = require('./handleListingPage');

function dispatchPageFunctions() {
  if (activePageType === SINGLE_PAGE) {
    handleSinglePage();
  } else if (activePageType === LISTING_PAGE) {
    handleListingPage();
  }
}

module.exports = dispatchPageFunctions;


// WEBPACK FOOTER //
// ./modules/dispatchPageActions.js